import React, { useRef, useCallback, useImperativeHandle, forwardRef } from 'react';
import { setLivefeedOptions, setLivefeedGlobalOptions } from 'actions/livefeed/livefeedOptions'
import { useDispatch, useSelector } from 'react-redux'
import CustomScrollBar from 'components/common/CustomScrollBar'
import ReactTooltip from "react-tooltip";
import WidgetOption from './WidgetOption'
import LocationOption from './LocationOption'
import DurationOption from './DurationOption'
import ScrollOption from './ScrollOption'
import SensorOption from './SensorOption'
import MapConfig from './MapConfig'
import './index.less'
const FloorplanOptionContainer = forwardRef(({ editorMode }, ref, ) => {
    const dispatch = useDispatch();
    let { mapConfigMode, livefeedSlides, slideCurrentIndex } = useSelector(state => state.livefeededitor)
    const {
        slideType,
        floorplanOptions: {
            locationsID, duration: slideDuration, widgetLabelType,
            sensorFilterType, isStandbyAsUnOccupied, lockScroll
        }
    } = livefeedSlides[slideCurrentIndex];
    const tree = useSelector(state => state.overviewReducer.customerOverview)
    const nodeMap = useSelector(state => state.overviewReducer.nodeMap)

    // -------------- forwardRef
    const locationOptionRef = useRef(null)
    const apiInputRef = useRef(null)
    useImperativeHandle(ref, () => ({
        openLocationsModal: () => {
            locationOptionRef.current.openLocationsModal()
        },
        focusMapApiInput: () => {
            apiInputRef.current.focusMapApiInput()
        }
    }));

    // single option
    const setLivefeedOptionsHandle = useCallback((type, value) => {
        dispatch(setLivefeedOptions(type, value))
    }, [dispatch])

    // global option
    const setLivefeedGlobalOptionsHandle = useCallback((type, value) => {
        dispatch(setLivefeedGlobalOptions(type, value))
    }, [dispatch])

    const renderOptions = () => {
        return (
            <div className="editor-pane-container" >
                {(slideType !== "summary" && slideType !== "locationsList") &&
                    <MapConfig
                        dispatch={dispatch}
                        ref={apiInputRef}
                        mapConfigMode={mapConfigMode}
                        livefeedSlides={livefeedSlides}
                        slideCurrentIndex={slideCurrentIndex}
                        setLivefeedOptionsHandle={(type, value) => setLivefeedOptionsHandle(type, value)}
                        setLivefeedGlobalOptionsHandle={(mapConfig) => setLivefeedGlobalOptionsHandle("globalMapConfig", mapConfig)}
                    />
                }
                {slideType !== "locationsList" &&
                    <LocationOption
                        editorMode={editorMode}
                        dispatch={dispatch}
                        nodeMap={nodeMap}
                        livefeedSlides={livefeedSlides}
                        slideType={slideType}
                        locationsID={locationsID}
                        tree={tree}
                        ref={locationOptionRef}
                        setLivefeedOptionsHandle={(type, value, ) => setLivefeedOptionsHandle(type, value)}
                    />
                }
                <DurationOption
                    slideDuration={slideDuration}
                    setLivefeedOptionsHandle={(value) => setLivefeedOptionsHandle("slideDuration", value)}
                    setLivefeedGlobalOptionsHandle={(value) => setLivefeedGlobalOptionsHandle("globalSlideDuration", value)}
                />
                {(slideType !== "summary" && slideType !== "locationsList") &&
                    <ScrollOption
                        lockScroll={lockScroll}
                        setLivefeedOptionsHandle={(value) => setLivefeedOptionsHandle("lockscroll", value)}
                        setLivefeedGlobalOptionsHandle={(value) => setLivefeedGlobalOptionsHandle("globalLockScroll", value)}
                    />
                }
                {slideType !== "locationsList" &&
                    <WidgetOption
                        widgetLabelType={widgetLabelType}
                        setLivefeedOptionsHandle={(value) => setLivefeedOptionsHandle("widgetLabelType", value)}
                        setLivefeedGlobalOptionsHandle={(value) => setLivefeedGlobalOptionsHandle("globalWidget", value)}
                    />}
                {(slideType !== "locationsList") &&
                    <SensorOption
                        slideType={slideType}
                        isStandbyAsUnOccupied={isStandbyAsUnOccupied}
                        sensorFilterType={sensorFilterType}
                        setLivefeedOptionsHandle={(type, value) => setLivefeedOptionsHandle(type, value)}
                        setLivefeedGlobalOptionsHandle={(value) => setLivefeedGlobalOptionsHandle("globalSensorFilter", value)}
                    />
                }
                <ReactTooltip id="floorplanOptionsTooltip" place="top" type="dark" effect="solid" />
            </div>
        )
    }
    return (
        <React.Fragment>
            {(slideType !== "locationsList") ?
                <CustomScrollBar className="scrollbar-container" noScrollX={true} containerStyle={{ height: 450, marginLeft: 20 }}>
                    {renderOptions()}
                </CustomScrollBar>
                :
                <div style={{ marginLeft: 20 }}>
                    {renderOptions()}
                </div>
            }
        </React.Fragment>

    );
})
export default FloorplanOptionContainer;




// WEBPACK FOOTER //
// ./src/components/pages/livefeed/Editor/EditorContainer/FloorplanOptionContainer/index.jsx